import React from 'react'

import { Alert, AlertDescription } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'
import { COMMON_DATA_ERROR_MESSAGE } from '@/lib/constants'

const CommonDataErrorMessage: React.FC = () => (
  <Alert variant="critical" className="mb-4">
    <AlertDescription>
      <p className="mb-4 pb-4">
        {COMMON_DATA_ERROR_MESSAGE}. Run the{' '}
        <Button asChild variant="link">
          <a
            href="https://github.com/RQ-Ratings/dev/blob/master/clean-environment.sh"
            className="text-white underline"
            target="_blank"
            rel="noreferrer"
          >
            clean-environment.sh
          </a>{' '}
        </Button>
        script to clear the cache.
      </p>
    </AlertDescription>
  </Alert>
)

export default CommonDataErrorMessage
